import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Card, Button } from 'antd';
import PropTypes from 'prop-types';
import { request } from '../utils/http';
import HelpTooltip from './helpTooltip';

const CacheItem = forwardRef(({ countUrl, onClear, name, label, info }, ref) => {
	const [cacheCount, setCacheCount] = useState(null);

	const updateCacheCount = async () => {
		const result = await request('GET', countUrl).catch(() => null);

		if (result) {
			setCacheCount(result);
		} else {
			setCacheCount(0);
		}
	};

	// Expose the updateCacheCount function to the parent via ref
	useImperativeHandle(ref, () => ({
		updateCacheCount,
	}));

	useEffect(() => {
		if (!cacheCount && countUrl !== '') {
			updateCacheCount();
		}
	}, [cacheCount, countUrl]);

	return (
		<Card
			title={
				<span>
					{name}
					{info && <HelpTooltip title={info} />}
				</span>
			}
			extra={
				onClear !== null && (
					<Button type='danger' size='default' icon='delete' onClick={() => onClear()}>
						Rensa
					</Button>
				)
			}
		>
			{cacheCount !== null && (
				<p>
					<b>{label || 'Antal nycklar'}: </b>
					{cacheCount}
				</p>
			)}
		</Card>
	);
});

CacheItem.defaultProps = {
	countUrl: '',
};

CacheItem.propTypes = {
	countUrl: PropTypes.string,
	onClear: PropTypes.func,
	name: PropTypes.string.isRequired,
	info: PropTypes.string,
};

export default CacheItem;

export { CacheItem };



// WEBPACK FOOTER //
// ./src/components/cacheItem.jsx